export const prospectWillingnessLabels: { [key: string]: string } = {
  1: 'Per niente motivato',
  2: 'Poco motivato',
  3: 'Neutro',
  4: 'Abbastanza motivato',
  5: 'Molto motivato',
};
